import { LocationStrategy } from '@angular/common';
import { Injectable } from '@angular/core';
import { environment } from '../environments/environment';

export interface IEbbPortalEnviron {
    uriApi: string;
    uriApiRoot: string;
    uriEbbFiles: string;
    uriEbbAssets: string;
    uriSiteRoot: string;
    ebbSiteRoot: string;
    essSiteRoot: string;
    ebbApi: string;
    essApi: string;
    originSiteRoot: string;
    uriEbbSpaRedirect: string;
    programTypeCodeOptionSet:string;
    ProgramIsEbb: boolean;
    ProgramIsCeaBb: boolean;
    ProgramIsEss: boolean;
}

@Injectable({ providedIn: 'root' })
export class AppLoadService {
    static environSettings: IEbbPortalEnviron = {
        uriApi:'',
        uriApiRoot:'',
        uriEbbFiles:'',
        uriEbbAssets:'',
        uriSiteRoot:'',
        ebbSiteRoot:'',
        essSiteRoot:'',
        ebbApi:'',
        essApi:'',
        originSiteRoot: '',
        uriEbbSpaRedirect:'',
        programTypeCodeOptionSet:'',
        ProgramIsEbb: true,
        ProgramIsCeaBb: false,
        ProgramIsEss: false
    } as IEbbPortalEnviron;

    constructor(
        private locationStrategy: LocationStrategy) { }

    public getEnvironSettings(): Promise<any> {
        return new Promise((resolve, reject) => {
            if (environment.api) {
                AppLoadService.environSettings.uriApi = environment.api;

                if (AppLoadService.environSettings.uriApi.slice(-1) === '/') {
                    AppLoadService.environSettings.uriApi = AppLoadService.environSettings.uriApi.slice(0, -1);
                }

                AppLoadService.environSettings.uriApiRoot = AppLoadService.environSettings.uriApi.substr(0, AppLoadService.environSettings.uriApi.lastIndexOf('\/'));
                AppLoadService.environSettings.uriEbbFiles = AppLoadService.environSettings.uriApi.substr(0, AppLoadService.environSettings.uriApi.lastIndexOf('\/'));
                AppLoadService.environSettings.uriEbbAssets = `${AppLoadService.environSettings.uriEbbFiles}/files/portal/assets`;
                AppLoadService.environSettings.uriEbbSpaRedirect =  `${AppLoadService.environSettings.uriEbbFiles}/files/portal/authorization`;
            } else {
                AppLoadService.environSettings.uriApi = `https://${environment.apiDev}/api`;
                AppLoadService.environSettings.uriApiRoot = `https://${environment.apiDev}/`;
                AppLoadService.environSettings.uriEbbFiles = '';
                AppLoadService.environSettings.uriEbbAssets = '/assets'
                AppLoadService.environSettings.uriEbbSpaRedirect = 'http://localhost:4577/authorization';
            }

            //spa root
            if (window['spaBaseUrl']) {
                AppLoadService.environSettings.uriSiteRoot = window['spaBaseUrl'];
            } else {
                const baseurl = window.location.origin;
                AppLoadService.environSettings.uriSiteRoot = `${baseurl}${this.locationStrategy.getBaseHref()}`;
            }

            if (AppLoadService.environSettings.uriSiteRoot.slice(-1) === '/') {
                AppLoadService.environSettings.uriSiteRoot = AppLoadService.environSettings.uriSiteRoot.slice(0, -1);
            }

            const programtypes = window['program'];

            //cea program
            if (programtypes) {
              AppLoadService.environSettings.programTypeCodeOptionSet = window['program'];
            } else {
              AppLoadService.environSettings.programTypeCodeOptionSet = 'FEMA|EBB|ESS'; //default to EBB programs
            }
            
            const programsSplit = AppLoadService.environSettings.programTypeCodeOptionSet.split('|');
            AppLoadService.environSettings.ProgramIsCeaBb = programsSplit.filter(program => program === 'CEA BB').length >= 1;
            AppLoadService.environSettings.ProgramIsEss = programsSplit.filter(program => program === 'ESS').length >= 1;
            AppLoadService.environSettings.ProgramIsEbb = !(AppLoadService.environSettings.ProgramIsCeaBb || AppLoadService.environSettings.ProgramIsEss);

            //developer overwrite
            //make sure to comment before pushing code changes
            //AppLoadService.environSettings.ProgramIsEbb = false;
            //AppLoadService.environSettings.ProgramIsCeaBb = false;
            //AppLoadService.environSettings.ProgramIsEss = true;

            let enviro = '';
            if(this.isEnvironment('dv') || this.isEnvironment('localhost')) {
                enviro = 'dv';
            }
            else if(this.isEnvironment('qa')) {
                enviro = 'qa';
            }
            else if(this.isEnvironment('ua')) {
                enviro = 'ua';
            }
            else if(this.isEnvironment('mo')) {
                enviro = 'mo';
            }
            else {
                enviro = 'pd';
            }

            if(enviro === 'pd')  {
                AppLoadService.environSettings.ebbSiteRoot = `https://www.earthquakebracebolt.com`;
                AppLoadService.environSettings.ebbApi = `https://api.www.earthquakebracebolt.com/api`;
    
                AppLoadService.environSettings.essSiteRoot = `https://www.californiaresidentialmitigationprogram.com`;
                AppLoadService.environSettings.essApi = `https://api.www.californiaresidentialmitigationprogram.com/api`;
            }
            else {
                AppLoadService.environSettings.ebbSiteRoot = `https://cms-${enviro}2.earthquakebracebolt.com`;
                AppLoadService.environSettings.ebbApi = `https://api.cms-${enviro}2.earthquakebracebolt.com/api`;
    
                AppLoadService.environSettings.essSiteRoot = `https://${enviro}.californiaresidentialmitigationprogram.com`;
                AppLoadService.environSettings.essApi = `https://api.${enviro}.californiaresidentialmitigationprogram.com/api`;
            }
            

            if(window.location.hostname.includes('californiaresidentialmitigationprogram.com'))  {
                AppLoadService.environSettings.originSiteRoot = AppLoadService.environSettings.essSiteRoot;
            }
            else {
                AppLoadService.environSettings.originSiteRoot = AppLoadService.environSettings.ebbSiteRoot;
            }

            resolve(true);
        });
    }

    public readEnvironSettings(): IEbbPortalEnviron {
        return AppLoadService.environSettings;
    }

    private isEnvironment(env: string) : boolean  {
        return AppLoadService.environSettings.uriApi.includes('.' + env + '.') ||
        AppLoadService.environSettings.uriApi.includes('-' + env) ||
        AppLoadService.environSettings.uriApi.includes(env + '.') ||
        AppLoadService.environSettings.uriApi.includes(env + '2.')
    }
}
